import io from 'socket.io-client'
import APP_ENVIRONMENT from '../environment/environment'
import localStorageService from './localStorage'

const URL_SOCKET = APP_ENVIRONMENT.PATH.SOCKET_AUCTION
export const socketUser = io(`${URL_SOCKET}`, {
  path: '/socket',
  transports: ['websocket'],
  autoConnect: false,
})
export const socketAdmin = io(`${URL_SOCKET}/admin`, {
  path: '/socket',
  transports: ['websocket'],
  autoConnect: false,
})
export const getAuctionSocket = () => {
  const userData = localStorageService.get()
  if (userData?.roleId < 5) {
    return socketAdmin
  } else {
    return socketUser
  }
}
export const connectAuctionSocket = (user = undefined) => {
  /* Magic trick to update query and reconnect with new credentials
     is used to make work guest and auth user */
  const userToken = localStorageService.get('token')
  const userData = user || localStorageService.get()
  let socket = userData.roleId < 5 ? socketAdmin : socketUser
  if (userToken && userData) {
    if (userData.roleId < 5) {
      if (!socket.connected) {
        console.log('conectando a adminSocket')
        socket.io.opts.query = {
          ...userData,
          isGuest: false,
          userToken,
        }
        socket.connect()
        console.log('conectado a adminSocket')
      }
    } else {
      if (!socket.connected && !userData.isGuest) {
        console.log('conectando a userSocket', socketUser)
        socket.io.opts.query = {
          ...userData,
          isGuest: false,
          userToken,
        }
        console.log('socketUser', socketUser)
        socket.connect()
      } else {
        console.log('conectando a userSocket como visitante')
        if (userData) {
          socket.io.opts.query = {
            ...userData,
            externalId: userData.externalId
          }
          socket.connect()
        }
      }
    }
  }
  return socket
}
